import type { WebContainerProcess } from '@webcontainer/api';
import { logger } from '~/utils/logger';

export async function getOutput(process: WebContainerProcess, callback: (arg: string) => void) {
  process.output.pipeTo(
    new WritableStream({
      write(data) {
        try {
          callback(data);
        } catch (error: any) {
          logger.error(data, error);
          return;
        }
      },
    }),
  );

  await process.exit;
}

export async function getOutputAsString(process: WebContainerProcess): Promise<string> {
  let output = '';

  await getOutput(process, (data) => {
    output += data;
  });

  return output;
}
